export enum ValidationStatus {
  NOT_STARTED = 1,
  SUCCESS = 2,
  FAILED = 3,
  WARNING = 4,
}
